import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';

var IconTickFilledSVG = (props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("g", {
  id: "Icon/Tick-Filled",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React__default.createElement("circle", {
  className: "motorway-svg-fill",
  id: "Oval-35",
  fill: "#00BC80",
  cx: "12",
  cy: "12",
  r: "10"
}), /*#__PURE__*/React__default.createElement("polyline", {
  className: "motorway-svg-stroke",
  id: "Path-35",
  stroke: "#FFFFFF",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "8 11.8023926 10.7399541 15 16 9"
}))));

export { IconTickFilledSVG as I };
